module.exports = __webpack_public_path__ + "media/images/voice07-04914a39d989c0f8ee8df4e47ad4fdab.jpg";